import { StackProps, Text, VStack } from '@elkaso-app/web-design';

export interface IPocBrandDetailsCell extends StackProps {
  name: string;
}

export const PocBrandDetailsCell = ({ name, ...rest }: IPocBrandDetailsCell) => {
  return (
    <VStack spacing='sm' align='start' {...rest}>
      <Text
        whiteSpace='pre-line'
        color={'blue.500'}
        fontWeight='500'
        _hover={{ color: 'blue.500' }}
        _focus={{ color: 'blue.500' }}>
        {name}
      </Text>
    </VStack>
  );
};
